var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-70475bf1\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./FwUpdate.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/FwUpdates/FwUpdate.vue
// module id = 170
// module chunks = 1